import { NewContractSchema } from '@weft/types';
import { z } from 'zod';
import { PlanAssignmentCustomerDataSchema } from './plan-assignment-customer-data-schema';

export const NewPlanAssignmentSchema = z.object({
  contract: NewContractSchema,
  selectedCustomers: z.array(PlanAssignmentCustomerDataSchema),
});

export type NewPlanAssignment = z.infer<typeof NewPlanAssignmentSchema>;